import { useEffect } from"react";

const useTsgTrigger = (ref, onTrigger) => {
 useEffect(() => {
 if (!ref?.current) return;

 const handleKeyUp = () => {
 const el = ref.current;
 const text = el?.value?.trim() ??"";

 // Trigger only when @tsg is the last word
 if (text.endsWith("@tsg")) {
 console.log("✅ @tsg detected, triggering palette...");
 onTrigger();
 }
 };

 const el = ref.current;
 el.addEventListener("keyup", handleKeyUp);

 return () => {
 el.removeEventListener("keyup", handleKeyUp);
 };
 }, [ref, onTrigger]);
};

export default useTsgTrigger;



